import { mapNullable } from 'annotation-tools/utils';
import {
  AnnotationAPIRawRequestBodyType,
  AnnotationAPIRequestBodyType,
  CreateAnnotationAPIRawRequestBodyType,
  CreateAnnotationAPIRequestBodyType
} from '../../types/annotation/api-request-body';
import { IRectToRawRectangle } from '../../types/common/raw-rectangle';

export const AnnotationAPIRequestBody = ({
  labelId,
  rect
}: AnnotationAPIRequestBodyType): AnnotationAPIRawRequestBodyType => ({
  label: labelId,
  rectangle: IRectToRawRectangle(rect)
});

export const AnnotationAPIRequestBodyPartial = ({
  labelId,
  rect
}: Partial<
  AnnotationAPIRequestBodyType
>): Partial<AnnotationAPIRawRequestBodyType> => ({
  label: labelId,
  rectangle: mapNullable(rect, IRectToRawRectangle)
});

export const CreateAnnotationAPIRequestBody = ({
  uuid,
  labelId,
  rect
}: CreateAnnotationAPIRequestBodyType): CreateAnnotationAPIRawRequestBodyType => ({
  uid: uuid,
  label: labelId,
  rectangle: IRectToRawRectangle(rect)
});
